import { render, staticRenderFns } from "./exhibition-info-fasciaBoard.vue?vue&type=template&id=764bbb6a&scoped=true&"
import script from "./exhibition-info-fasciaBoard.vue?vue&type=script&lang=js&"
export * from "./exhibition-info-fasciaBoard.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-info-fasciaBoard.vue?vue&type=style&index=0&id=764bbb6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764bbb6a",
  null
  
)

export default component.exports